import { CurrencyISO } from '@/constants/currencies';

import type { CellData as RootCellData } from '../types';

import { getCellTemplate } from './utils';

export const kind = 'share-price-cell' as const;

export interface SharePriceCellData
  extends RootCellData<typeof kind, number | null> {
  currencyISO: CurrencyISO | null;
  error: string | null;
}

export type SharePriceCell = ReturnType<typeof getCellTemplate>;
